const districtAdminPages = {
  dashboard: {
    getRoute: (districtId: number) => `/districts/${districtId}/dashboard`,
    v1: false,
  },
  admins: {
    getRoute: (districtId: number) => `/districts/${districtId}/admins`,
    v1: false,
  },
  schools: {
    getRoute: (districtId: number) => `/districts/${districtId}/schools`,
    v1: false,
  },
  schoolDrilldown: {
    getRoute: (districtId: number, schoolId: number) => `/districts/${districtId}/schools/${schoolId}`,
    v1: false,
  },
  teachers: {
    getRoute: (districtId: number) => `/districts/${districtId}/teachers`,
    v1: false,
  },
  teacherDrilldown: {
    getRoute: (districtId: number, schoolId: number, teacherId: number) => `/districts/${districtId}/schools/${schoolId}/teachers/${teacherId}/classrooms`,
    v1: false,
  },
  classroomDrilldown: {
    getRoute: (districtId: number, schoolId: number, teacherId: number, classroomId: number) => `/districts/${districtId}/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}`,
    v1: false,
  },
  studentDrilldown: {
    getRoute: (districtId: number, schoolId: number, teacherId: number, classroomId: number, studentId: number) => `/districts/${districtId}/schools/${schoolId}/teachers/${teacherId}/classrooms/${classroomId}/students/${studentId}`,
    v1: false,
  },
}

export const defaultDistrictAdminPage = districtAdminPages.dashboard

export default districtAdminPages
